const selectors = {
  getIsFetchingAllGroups: state => state.groups.get('isFetchingAllGroups'),
  getDistrictAllGroups: (state, district) =>
    state.groups.getIn(['allGroups', district])
};

export default selectors;
